import Avatar, { SizeType } from '@atlaskit/avatar';
import EllipsisOverflow from '@databases/field-value/common/EllipsisOverflow';
import { defaultStoreUtils } from '@databases/redux';
import { Group, isUser, User } from '@databases/types/confluence';
import { selectBaseUrl } from '@databases/utils/redux/context/selectors';
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

const GROUP_AVATAR_PATH = '/images/icons/avatar_group_48.png';

const Container = styled.div`
  display: flex;
  align-items: center;

  > :first-child {
    margin-right: 3px;
  }
`;

interface AvatarWithLabelProps {
  userOrGroup: User | Group | undefined;
  label?: ReactNode;
  size?: SizeType;
  className?: string;
}

const AvatarWithLabel: FunctionComponent<AvatarWithLabelProps> = ({
  userOrGroup,
  label,
  size,
  className,
}) => {
  const displayName = !userOrGroup
    ? ''
    : isUser(userOrGroup)
    ? userOrGroup.displayName
    : userOrGroup.name;

  const baseUrl = defaultStoreUtils.useSelector(selectBaseUrl);

  return (
    <Container className={className}>
      <Avatar
        appearance="circle"
        size={size}
        src={
          !userOrGroup
            ? undefined
            : isUser(userOrGroup)
            ? new URL(userOrGroup.profilePicture.path, baseUrl).toString()
            : `${baseUrl}${GROUP_AVATAR_PATH}`
        }
        borderColor="none"
        name={label != null ? displayName : undefined}
      />
      <EllipsisOverflow>{label ?? displayName}</EllipsisOverflow>
    </Container>
  );
};

export default AvatarWithLabel;
